import { createSelector } from 'reselect';

const EMPTY_RUN_HISTORY = Object.freeze({ rows: [], totalCount: 0, page: 1, pageSize: 25 });

export const selectMobileRoutes = (state) => state.mobileRoutes;

export const selectList = (state) => state.mobileRoutes.list;

export const selectListRows = createSelector(selectList, (list) => list.rows);

export const selectSelected = (state) => state.mobileRoutes.selected;

export const selectSelectedRun = (state) => state.mobileRoutes.selectedRun;

export const selectRunHistory = (state, mobileRouteID) =>
  state.mobileRoutes.runHistory[mobileRouteID] || EMPTY_RUN_HISTORY;

export const selectRunsList = (state) => state.mobileRoutes.runsList;

export const selectRunsListRows = createSelector(selectRunsList, (runsList) => runsList.rows);

export const selectError = (state, operation) => state.mobileRoutes.errors[operation] || null;

export const selectLoading = (state, operation) => Boolean(state.mobileRoutes.loading[operation]);
